import NewsPosts from '../components/news-posts.svelte'
import DropDown from '../components/dropdown.svelte'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const { $ } = window
export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		let tl = gsap.timeline()
		let $archFilterWrap = $('#archive-filter-wrap')
		if ($archFilterWrap.length) {
			console.log(categoryData.items)
			new DropDown({
				target: $archFilterWrap[0],
				props: {
					allLabel: categoryData.allLabel,
					items: categoryData.items,
				},
			})
		}
		let $newsWrap = $('#news-section-wrap')
		if ($newsWrap.length) {
			new NewsPosts({
				target: $newsWrap[0],
				props: $newsWrap.data(),
			})
		}

		$('.h-underline').each((idx, el) => {
			tl.to(el, {
				scrollTrigger: {
					trigger: el,
				},
				y: 0,
				duration: 0.35,
				opacity: 1,
			})
		})
		gsap.set('.news-post', { y: 32 })
		$('.news-post').each((idx, el) => {
			tl.to(el, {
				scrollTrigger: {
					trigger: el,
				},
				y: 0,
				// stagger: 0.1,
				// delay: 0.1*(idx%2),
				duration: 0.35,
				opacity: 1,
			})
		})

		const toggleBtn = $('.cat-nav button')
		const dropDown = $('.cat-nav ul')

		$(window).on('load resize', function () {
			if ($(window).width() < 768) {
				$(dropDown).hide(0)
				$(dropDown).css('visibility', 'visible')
			} else {
				$(dropDown).show(0)
				$(toggleBtn).removeClass('open')
			}
		})

		$(toggleBtn).click(function (e) {
			e.preventDefault()
			$(this).toggleClass('open')
			$(dropDown).fadeToggle(250)
		})

		// filterSubCats()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function filterSubCats() {
	let subCatBtns = document.querySelectorAll('.filter-link')
	let subCatGroups = document.querySelectorAll('.cards-group')
	// console.log(subCatGroups)

	function removeActiveClass() {
		subCatBtns.forEach((btn, index) => {
			btn.classList.remove('active')
		})
	}
	subCatBtns.forEach((btn, _i) => {
		if(!btn.querySelector('a')) { return; }
		btn.querySelector('a').addEventListener('click', (e) => {
			e.preventDefault()
			if (btn.classList.contains('active')) {
				return
			} else {
				removeActiveClass()
				btn.classList.add('active')
				window.location.href = e.target.href
			}
		})
	})
}
